const HelpCategory = {
  helpCategory: 'Help Category',
  addHelpCategory: 'Add Help Category',
  editHelpCategory: 'Edit Help Category',
};
export default HelpCategory;
